// Updated GSAP ScrollTrigger script for all sections
// Make sure GSAP and ScrollTrigger are loaded before this script

// Wait until DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // === SECTION 1: Feature Slider Animations ===
  const featureSlider = document.querySelector(".s-feature-slider");
  if (featureSlider) {
    const title = featureSlider.querySelector(".s-feature-slider__title");
    const slides = featureSlider.querySelectorAll(".s-feature-slider__slide");

    gsap.fromTo(
      featureSlider,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: featureSlider,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: featureSlider,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    slides.forEach((slide, index) => {
      gsap.fromTo(slide, { y: 40, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        delay: index * 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slide,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      });
    });
  }

  // === SECTION 2: Catalog Download Animation ===
  const catalogSection = document.querySelector('.s-catalog-download');

  if (catalogSection) {
    const title = catalogSection.querySelector('.s-catalog-download__title');
    const text = catalogSection.querySelector('.s-catalog-download__text');
    const button = catalogSection.querySelector('.why-us-section__link');

    // Section fade-out
    gsap.fromTo(
      catalogSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: catalogSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Title animation
    if (title) {
      gsap.fromTo(
        title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Text animation
    if (text) {
      gsap.fromTo(
        text,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Button animation (same style as others)
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.35,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // Always refresh ScrollTrigger to ensure layout is measured correctly
  ScrollTrigger.refresh();
});
